<template>
    <div>
        <div class="second-header-wrap">
            <el-button type="default" size="medium" @click="$router.back()">返回</el-button>
            <el-button type="primary" size="medium" @click="jumpToPage('resourceAdd', {courseId, courseLevelCode: courseDetail.courseLevelCode, areaCode: courseDetail.areaCode})">添加资源</el-button>
            <el-input placeholder="请输入资源" v-model.trim="searchTitle" class="search-input" @keyup.enter.native="searchTitleHandler">
                <el-button slot="append" icon="el-icon-search" @click="searchTitleHandler"></el-button>
            </el-input>

            <div class="course-name-container">
                <span class="course-name">{{courseDetail.courseName}}（{{parsePeriod(courseDetail.courseLevelCode)}}）</span>
            </div>
        </div>
        <div class="main-content-wrap custom—scrollbar" :style="{height: mainContainerHeight}">
            <div v-if="dataList && dataList.length !== 0" class="inner-content-wrap">
                <div class="main-container">
                    <ul>
                        <li @click="jumpToPage('resourceDetail', {resourceId: resourceItem.id, fromType: 'manage', courseLevelCode: courseDetail.courseLevelCode})" class="resource-card-item" :key="index" v-for="(resourceItem, index) in dataList">
                            <div class="inner-card-wrap">
                                <div class="item-img-wrap">
                                    <div class="item-cover"
                                         :style="{backgroundImage: `url(${resourceItem.resourceLogo})`}">
                                    </div>
                                </div>
                                <div class="card-msg-wrap">
                                    <div>
                                        <span class="resource-name">
                                            <el-tooltip class="item" effect="dark" :content="resourceItem.resourseName" placement="top">
                                                <div>{{resourceItem.resourseName}}</div>
                                            </el-tooltip>
                                        </span>
                                        <span class="resource-status">
                                            {{resourceItem.status === 2 ? '已发布' : '草稿'}}
                                        </span>
                                        <i class="el-icon-edit" style="color: #409EFF;" @click.stop="jumpToPage('resourceEdit', {resourceId: resourceItem.id, courseId, courseLevelCode: courseDetail.courseLevelCode, areaCode: courseDetail.areaCode})"></i>
                                        <i class="el-icon-delete" style="color: #F56C6C;" @click.stop="deleteResource(resourceItem.id)"></i>
                                    </div>
                                    <div class="resource-title clearfix">
                                        <div><i class="fa fa-eye"></i>观看:<span>{{resourceItem.visitorCount}}</span></div>
                                        <div><i class="fa fa-thumbs-o-up"></i>点赞:<span>{{resourceItem.praiseCount}}</span></div>
                                        <div><i class="fa fa-comment-o"></i>评论:<span>{{resourceItem.commentCount}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="dataList && dataList.length !== 0" class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[8, 16, 32]"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
            <default-page v-else></default-page>
        </div>
    </div>
</template>

<script>
    import DefaultPage from '@/components/DefaultPage';
    import baseMixin from '@/mixins/baseMixin.js'
    import { getMoralEduOLResourcePageList, getMoralEduOLCourseInfo, deleteMoralEduOLResource } from '@/api/resourceManagement/resourceManagement';
    import { findDicsByCode } from '@/api/common/common';

    export default {
        name: "resourceList",
        data() {
            return {
                courseId: this.$route.query.courseId,
                mainContainerHeight: 0,
                searchTitle: '',
                searchTitleArg: '',
                searchType: 0,
                courseDetail: {
                    courseName: '',
                    courseLevelCode: null
                },
                schoolPeriodList: [],
                dataList: []
            }
        },
        components: {
            DefaultPage
        },
        mixins: [baseMixin],
        created() {
            this.pagination.pageSize = 8;
            findDicsByCode({
                dicCode: 'schoolPeriodType'
            })
                .then(res => res.data)
                .then(data => {
                    if(data.data.length > 0) {
                        this.schoolPeriodList = data.data;
                        getMoralEduOLCourseInfo({
                            id: this.courseId
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.courseDetail = data.data;
                            });
                    }
                });

            this.getMoralEduOLResourcePageListFunc();
        },
        mounted() {
            this.mainContainerHeight = `${window.innerHeight - 162}px`;
        },
        methods: {
            searchTitleHandler() {
                this.searchTitleArg = this.searchTitle;
                this.getMoralEduOLResourcePageListFunc();
            },
            sizeChangeHandler(pageSize) {

                this.pagination.pageSize = pageSize;
                this.pagination.pageNo = 1;
                this.getMoralEduOLResourcePageListFunc();
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getMoralEduOLResourcePageListFunc();
            },
            parsePeriod(period) {
                if(period !== null) {
                    const periodItem = this.schoolPeriodList.find(({code}) => {
                        return code === period
                    });
                    return periodItem ? periodItem.value : period;
                } else {
                    return '';
                }
            },
            getMoralEduOLResourcePageListFunc() {
                getMoralEduOLResourcePageList({
                    courseId: this.courseId,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    searchTitle: this.searchTitleArg,
                    searchType: this.searchType
                })
                    .then(res => res.data)
                    .then(data => {
                        const dataList = data.data.dataList;
                        this.dataList = dataList;
                        this.pagination.total = dataList.length;
                        this.pagination.pages = data.data.pagination.pages;
                        this.pagination.total = data.data.pagination.total;
                    })
            },
            deleteResource(resourceId) {
                this.$confirm('是否确定要删除该资源', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteMoralEduOLResource({
                        id: resourceId
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getMoralEduOLResourcePageListFunc();
                            }
                        });

                }).catch();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";
    @import "../../../../commonsPC/styles/platform-global";


    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
        .course-name-container {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            text-align: left;
            font-size: 22px;
            line-height: 70px;
        }
    }

    .main-content-wrap {
        width: 100%;
        margin-top: 162px;
        background: url(../../assets/images/common/content-bg.jpg) center center / 100% 100% no-repeat;
        .inner-content-wrap {

            width: 100%;
            overflow-y: auto;
            height: 740px;
            .main-container {
                width: 1320px;
                padding: 30px 10px;
                margin: 0 auto;
                min-height: 560px;
                ul {
                    margin-left: -20px;
                    .resource-card-item {
                        float: left;
                        width: 315px;
                        height: 230px;
                        position: relative;
                        -webkit-transition: .3s all linear;
                        transition: .3s all linear;
                        margin-left: 20px;
                        margin-bottom: 50px;
                        background: #fff;
                        box-shadow: 1px 1px 1px 1px #ddd;
                        -webkit-box-shadow: 1px 1px 1px 1px #ddd;
                        .inner-card-wrap {
                            display: block;
                            width: 100%;
                            height: 100%;
                            text-decoration: none;
                            color: initial;
                            cursor: pointer;
                            .item-img-wrap {
                                width: 100%;
                                height: 175px;
                                overflow: hidden;
                                position: relative;
                                .item-cover {
                                    @include full;
                                    @include cover-bg;
                                    transition: all 0.6s;
                                }
                                .mask-item {
                                    width: 100%;
                                    height: 100%;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    background-color: rgba(0, 0, 0, 0.3);
                                    opacity: 0;
                                    filter: alpha(opacity=0);
                                    transition: all 0.3s;
                                    button {
                                        position: absolute;
                                        top: 70px;
                                        left: 90px;
                                        transition: ease-in 0.2s;
                                        &:nth-child(2) {
                                            left: 175px;
                                        }
                                        &:hover {
                                            top: 66px;
                                        }
                                    }
                                }
                            }
                            .card-msg-wrap {
                                width: 92%;
                                padding: 0 4%;
                                overflow: hidden;
                                .resource-title {
                                    font-size: 17px;
                                    & > * {
                                        @include middleIB;
                                        width: 32%;
                                        font-size: 14px;
                                    }
                                }
                            }
                        }
                        &:hover {
                            .mask-item {
                                opacity: 1 !important;
                            }
                            .item-cover {
                                transform: scale(1.15);
                            }
                        }
                    }
                }
            }
        }
    }
    .inner-content-wrap::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }
    .inner-content-wrap::-webkit-scrollbar-thumb {
        background-color: #999;
    }
    .inner-content-wrap::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
    .pagination-container {
        text-align: right;
        width: 1320px;
        margin: 10px auto 0 auto;
    }
    .resource-name, .resource-status {
        @include middleIB;

    }
    .resource-status {
        width: 33%;
        text-align: center;
        margin-right: 3px;
    }
    .resource-name {
        @include general-title;
        width: 50%;
        div {
            @include nowrap;
        }
    }
    .search-input {
        vertical-align: middle;
        margin-left: 10px;
        width: 240px;
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceManagement/resourceList.vue